import React from 'react'
import { app, use, api } from 'xadmin'
import { C } from 'xadmin-ui'
import _ from 'lodash'
import NodeListSelect from './../components/NodeListSelect'
import { Select } from 'antd'

const findContextParent = (cellKey, cells) => {
  const parentKey = cells[cellKey] && cells[cellKey].parent
  if (!parentKey || parentKey == 'root') return null
  const parent = cells[parentKey]
  if (parent && parent.params && parent.params.node && parent.params.node.uid) {
    return parentKey
  } else {
    return findContextParent(parentKey, cells)
  }
}

const OrderField = props => {
  const { modelId } = use('form', state => ({ modelId: state.values?.model?.id || state.values?.model?.[0]?.id }))
  const [state, setState] = React.useState({ model: null, tags: null, loading: false })

  const loadModel = async (id) => {
    setState({ loading: true })
    const model = await api({ name: 'core/model' }).get(id)
    setState({ model, loading: false })
  }

  React.useEffect(() => {
    modelId && loadModel(modelId)
  }, [modelId])

  const convertProps = (properties) => {
    let ops = []
    let list = Object.keys(properties) 
    const parseProps = (propertKeys, properties, prefix) => propertKeys.map(item => {
      const prev = properties[item] || {}
      if (prev.relateTo || prev.relate) {
        prev.properties = {}
      }
      if (prev.properties && !_.isEmpty(prev.properties)) {
        prev.key = item
        parseProps(Object.keys(prev.properties), prev.properties, prev)
      } else {
        const title = prev.title ? prefix && prefix.title ? prefix.title + '-' + prev.title : prev.title : item
        ops.push({
          ...prev,
          title,
          key: prefix && prefix.key ? prefix.key + '.' + item : item,
        })
      }
    })
    parseProps(list, properties)
    return ops
  }

  return (
    state.loading ? null : <C is="Model.ExtendsModel" name="Node" data={{ model: state.model }}>
      {newSchema => {
        const schema = modelId ? newSchema : app.get('models')['Node']
        const p = _.omit(schema?.properties, ['device', 'dashboard', 'warning', 'gis', 'videoRecord', 'hkvideo', 'network', 'computed'])
        const customProp = p?.custom?.properties
        if (customProp && !_.isEmpty(customProp)) {
          p.custom.properties = _.reduce(customProp, (p, c) => {
            if ((['object', 'array'].includes(c.type) && !c.relate && !c.relateTo) || c.fieldType == 'textEditor') {
              return p
            } else {
              return { ...p, [c.key]: c }
            }
          }, {})
        }
        const fields = !_.isEmpty(p) ? convertProps(p) : []
        if (props.input?.value && !fields.find(f => f.key == props.input.value)) {
          props.input?.onChange && props.input.onChange(null)
        }
        return (
          <Select {...props.input} allowClear>
            {fields.map(f => <Select.Option value={f.key}>{f.title}</Select.Option>)}
          </Select>
        )
      }}
    </C>
  )
}

const NSelect = props => {
  const { model, placeholder, department={}, multiple, defaultValue, input, nodeJump, editMode, insideFilter, initValue, orderField, orderType } = props
  const { dispatch, getDashboard, dashboard } = use('dashboard')
  const [ value, setValue] = React.useState()
  
  const onChange = value => {
    setValue(value)
    input.onChange(value)
    !editMode && nodeJump && value && app.go(`/app/model/node/${value.id}/view`)
  }

  let filter
  if (!_.isEmpty(insideFilter) && _.isArray(insideFilter)) {
    const f = _.compact(insideFilter.map(item => !_.isEmpty(item.values) ? _.reduce(item.values, (p, val, key) => {
      const k = key?.slice(0, -5)
      const m = item.methods?.[key] == 'include' ? '$in' : item.methods?.[key] == 'notInclude' ? '$nin' : null
      const v = m && _.isArray(val) ? { [m]: val?.map(v => v?.id || v) } : val
      return { ...p, [k]: v }
    }, {}) : null))
    filter = _.isEmpty(f) ? null : f.length == 1 ? f[0] : { '$or': f }
  } else {
    filter = insideFilter?.values ? _.mapKeys(insideFilter.values, (val, key) => key?.slice(0, -5)) : insideFilter?.values
  }

  const order = orderField ? { [orderField]: orderType || 'ASC' } : null

  return <NodeListSelect field={{ placeholder, multiple, model: model || dashboard && dashboard.data && dashboard.data.model, department: _.isArray(department) ? department : department?.id, insideFilter: filter, order }}
    input={{ onChange, value }} defaultValue={defaultValue} initValue={initValue} />
}

const paramSchema = {
  type: 'object',
  properties: {
    model: {
      title: '模型',
      type: 'array',
      fieldType: 'modelselect_multip',
      items: {},
    },
    department: {
      type: 'array',
      title: '部门',
      fieldType: 'department',
      items: {}
    },
    insideFilter: {
      title: '内置查询',
      type: 'object',
      properties: {},
      unbind: true,
      field: {
        component: props => {
          return <C is='QueryParams' {...props} timeRangeQuery={true} />
        }
      }
    },
    orderField: {
      title: '排序字段',
      type: 'string',
      description: '请设置排序字段及排序方式，默认不进行排序。',
      field: {
        component: OrderField,
        effect: ({ value }, form) => {
          setTimeout(() => {
            form.setFieldData('orderType', { display: !!value })
            !value && form.change('orderType', 'ASC')
          })
        }
      }
    },
    orderType: {
      title: '排序方式',
      type: 'string',
      enum: ['ASC', 'DESC'],
      enum_title: ['正序', '倒序']
    },
    multiple: {
      type: 'boolean',
      title: '多选',
      field: {
        effect: ( { value: multiple }, form ) => {
          form.setFieldData('nodeJump', { display: !multiple })
          multiple && form.change('nodeJump', false)
        }
      }
    },
    nodeJump: {
      type: 'boolean',
      title: '资产画面跳转',
    },
    initValue: {
      title: '默认值',
      type: 'boolean',
      description: '勾选后默认选中第一项，如果初始值和默认值同时存在，以初始值为准'
    },
    placeholder: {
      title: '提示文字',
      type: 'string',
      description: '选择器中的提示文本信息'
    }
  },
  formEffect: form => {
    form.useField('multiple', state => {
      let value = state.value
      form.setFieldData('nodeJump', { display: !value })
      value && form.change('nodeJump', false)
    })
  }
}

const NodeSelect = {
  title: '资产选择器',
  category: '业务选择器',
  icon: require('../icon/资产选择器.svg'),
  component: NSelect,
  initLayout: { width: 160, height: 34 },
  initParam: { placeholder: '请选择资产', orderType: 'ASC' },
  fieldWidget: true,
  paramSchema,
  theme: [
    { selector: '.ant-select .ant-select-selector', title: '选择器样式' }
  ]
}

export default NodeSelect
